import * as React from "react";
import { forwardRef } from "react";
const SvgDelete = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 15 14",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M4.44531 1.4V0H11.4453V1.4H14.9453V2.8H13.5453V13.3C13.5453 13.4857 13.4716 13.6637 13.3403 13.795C13.209 13.9263 13.031 14 12.8453 14H3.04531C2.85966 14 2.68161 13.9263 2.55034 13.795C2.41906 13.6637 2.34531 13.4857 2.34531 13.3V2.8H0.945312V1.4H4.44531ZM3.74531 2.8V12.6H12.1453V2.8H3.74531ZM5.84531 4.9H7.24531V10.5H5.84531V4.9ZM8.64531 4.9H10.0453V10.5H8.64531V4.9Z",
	fill: "currentColor"
}));
const ForwardRef = forwardRef(SvgDelete);
export default ForwardRef;
